export default [
  {
    path: '/real-estate-developments/:id/batch/info',
    name: 'RealEstateDevelopmentsUnitsBatchInfoList',
    component: () => import('pages/real-estate-developments/batch/RealEstateDevelopmentsBatchList.vue'),
    meta: { type: 'info' }
  },
  {
    path: '/real-estate-developments/:id/batch/price-tables',
    name: 'RealEstateDevelopmentsUnitsBatchPriceTablesList',
    component: () => import('pages/real-estate-developments/batch/RealEstateDevelopmentsBatchList.vue'),
    meta: { type: 'price-tables' }
  },
  {
    path: '/real-estate-developments/batch/info',
    name: 'RealEstateDevelopmentsBatchInfoList',
    component: () => import('pages/real-estate-developments/batch/RealEstateDevelopmentsBatchList.vue'),
    meta: { type: 'info' }
  },
  {
    path: '/real-estate-developments/batch/price-tables',
    name: 'RealEstateDevelopmentsBatchPriceTablesList',
    component: () => import('pages/real-estate-developments/batch/RealEstateDevelopmentsBatchList.vue'),
    meta: { type: 'price-tables' }
  }
]
